module.exports = __webpack_public_path__ + "a3718cb14a6e17a0bacf0f3247e24531.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Italic.svg
// module id = 353
// module chunks = 0